import { Dialog } from '@mui/material';

import { TouchpointKiosksTableContainer } from './touchpoint-kiosks-table/touchpoint-kiosks-table.container';

type KioskSelectionDialogProps = {
  open: boolean;
  onClose: () => void;
  onConfirm: (selectedIds: string[]) => void;
  initialKioskIds?: string[];
  maxSelection?: number;
  hideBulkSelect?: boolean;
};

export const KioskSelectionDialog = ({
  open,
  onClose,
  onConfirm,
  initialKioskIds = [],
  maxSelection,
  hideBulkSelect = false,
}: KioskSelectionDialogProps) => {
  return (
    <Dialog onClose={onClose} open={open} fullWidth maxWidth='md'>
      <TouchpointKiosksTableContainer
        onClose={onClose}
        onConfirm={onConfirm}
        initialKioskIds={initialKioskIds}
        maxSelection={maxSelection}
        hideBulkSelect={hideBulkSelect}
      />
    </Dialog>
  );
};
